var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClientSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52048 16.98H1C1 13.5443 3.78652 10.7678 7.21223 10.7678C7.51186 10.7678 8.16967 10.7878 8.4593 10.8277C8.4593 10.8277 7.96243 14.4232 9.52048 16.98ZM16.8702 11.8365C16.8102 11.8365 16.7503 11.8365 16.6904 11.8365C15.7815 11.8365 14.9526 11.427 14.3233 10.7578C13.6941 11.427 12.8652 11.8365 11.9563 11.8365C11.8964 11.8365 11.8365 11.8365 11.7765 11.8365C11.7066 12.176 11.6667 12.5256 11.6667 12.8951C11.6667 14.8627 12.7953 16.5106 14.3333 16.98C15.8614 16.5106 17 14.8627 17 12.8951C17 12.5256 16.96 12.176 16.8901 11.8365H16.8702ZM10.7678 4.55556C10.7678 6.51311 9.17978 8.11111 7.21223 8.11111C5.24469 8.11111 3.65668 6.5231 3.65668 4.55556C3.65668 2.58801 5.25468 1 7.21223 1C9.16979 1 10.7678 2.58801 10.7678 4.55556Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClientSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconClientSelected.2c95893f7b2922455ce169f1397302b3.svg";